import { emailValidationPattern } from "@cuauth/user-input-validation-rules";

import { DEFAULT_LOCALE, getMessages, type ValidationMessages } from "@/i18n";

import type { ValidationResult } from "./types";

export const EMAIL_MAX_LENGTH = 80;

export function validateEmail(
  value: string,
  validationMessages: ValidationMessages = getMessages(DEFAULT_LOCALE)
    .validation,
): ValidationResult {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return validationMessages.emailRequired;
  }

  if (trimmedValue.length > EMAIL_MAX_LENGTH) {
    return validationMessages.emailTooLong;
  }

  if (!emailValidationPattern.test(trimmedValue)) {
    return validationMessages.emailInvalidFormat;
  }

  return true;
}
